import $ from 'jquery';

export const replaceEmojiWithAltAttribute = (text) => {
    return text.replace(/<img .*?alt="(.*?)" class="emoji">/g, '$1');
};

export const isHtmlEmpty = (html) => {
    if (html.match(/<img .* class="emoji">/g)) {
        return false;
    }

    return $(html).text().replace(' ', '') === '';
};
